export default {
  Collector: 1,
  Print: 2,
  CountPrice: 3,
  SMS: 4,
  Freight: 5,
  FreightDispute: 6,
  Tax: 7,
  Packaging: 8,
  DistrictManagerShare: 9,
  SupervisorShare: 10,
  AvaexCommission: 11,
  serviceInPlace: 12,
  Insurance: 13,
  CodServices: 14,
};
